import { render, staticRenderFns } from "./cognitive-test.vue?vue&type=template&id=6446c6ed&scoped=true&"
import script from "./cognitive-test.vue?vue&type=script&lang=ts&"
export * from "./cognitive-test.vue?vue&type=script&lang=ts&"
import style0 from "./cognitive-test.vue?vue&type=style&index=0&id=6446c6ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446c6ed",
  null
  
)

export default component.exports